import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Avatar } from '../Avatar';

const PageHeaderAvatar = styled(Avatar).attrs({ size: 'large' })`
  background-color: ${theme.color.white};

  @media (min-width: ${theme.breakpoint.small}px) {
    margin-right: ${toRem(theme.space.lg)};
  }

  @media (min-width: ${theme.breakpoint.med}px) {
    margin-right: ${toRem(theme.space.xl)};
  }
`;

export default PageHeaderAvatar;
